export const LINKS = {
  // === Social / Profile ===
  LINKEDIN: 'https://www.linkedin.com/in/arora-sir/',
  LINKEDIN_RECOMMENDATIONS: 'https://www.linkedin.com/in/arora-sir/details/recommendations/',
  GITHUB: 'https://github.com/Arora-Sir/',
  LEETCODE: 'https://leetcode.com/arora_sir/',
  GEEKSFORGEEKS: 'https://auth.geeksforgeeks.org/user/arorasir/profile',
  TAKEU_FORWARD: 'https://takeuforward.org/profile/arorasir',

  // === Project links ===
  BUBBLE_SHOOTER_SPACE: 'https://www.madovergames.com/bubbleshooterspace/',
  SUPERHERO_HUNTER: 'https://github.com/Arora-Sir/SuperHero-Frontend-Project',
  STOPWATCH: 'https://github.com/Arora-Sir/StopWatch',

  // === Company / Institution ===
  MAD_OVER_GAMES: 'https://www.madovergames.com/',
  EXTRAMARKS: 'https://www.extramarks.com/',
  THINK_NEXT: 'https://www.thinknext.co.in/',
  THAPAR: 'https://www.thapar.edu/',
  DAV_SCHOOL: 'http://davmansa.in/',
  UN_SAID_TALKS: 'https://www.unsaidtalks.com/',
  FLUTTER_DEV: 'https://flutter.dev/',
  ACCIOJOB: 'https://acciojob.com/',

  // === Game Store Links (Experience.tsx & Projects.tsx) ===
  MOG_ANDROID_DEV_PAGE: 'https://play.google.com/store/apps/dev?id=7022253202210463993',
  MOG_IOS_DEV_PAGE: 'https://apps.apple.com/us/developer/madovergames/id1140588777',
  PVP_MATCH: 'https://play.google.com/store/apps/details?id=com.madovergames.pvpmatch.bubbleshooter.multiplayergame&hl=en_IN',
  BUBBLE_SHOOTER_SPACE_STORE: 'https://play.google.com/store/apps/details?id=com.madovergames.BubbleShooterSpace&hl=en_IN',
  BUBBLE_SHOOTER_SPACE_IOS: 'https://apps.apple.com/in/app/bubble-pop-space-shooter-game/id1670389649',
  BUBBLE_SHOOTER_CLASSIC: 'https://play.google.com/store/apps/details?id=com.madovergames.BubbleShooterClassic',
  BUBBLE_SHOOTER_PRO: 'https://play.google.com/store/apps/details?id=com.madovergames.BubbleShooterPro',
  KITTEN_GAMES: 'https://apps.apple.com/us/app/bubble-shooter-kitten-games/id1538913794',
  GUMMY_LAND: 'https://play.google.com/store/apps/details?id=com.madovergames.GummyLand',

  // === Side Projects & Open Source (SideProjects.tsx) ===
  DARQ_REBORN: 'https://github.com/Arora-Sir/DarQ-Reborn',
  TUFHUB_SITE: 'https://tufhub.mohitarora.me',
  TUFHUB_CHROME_STORE: 'https://chromewebstore.google.com/detail/tufhub/fbbjinonammckffpfmhicgdcfgodfnge',
  COPYCLIP: 'https://github.com/Arora-Sir/CopyClip',
  GRAVITY_BRIDGE: 'https://github.com/Arora-Sir/Gravity-Bridge',
  CHATALYTICS_PRO_LIVE: 'https://arora-sir.github.io/chatalytics-pro',
  CHATALYTICS_PRO_GITHUB: 'https://github.com/Arora-Sir/chatalytics-pro',
  MOVIE_ALERT: 'https://github.com/Arora-Sir/Movie-Alert',
  BLUEPRINT_HUB: 'https://arora-sir.github.io',

  // === Resume ===
  RESUME_VIEW: 'https://drive.google.com/file/d/1wYO-B7tVo97x-_Fm5d0jhgEaSvwAyNaR/view?usp=drive_link',
  RESUME_DOWNLOAD: 'https://drive.google.com/uc?export=download&id=1wYO-B7tVo97x-_Fm5d0jhgEaSvwAyNaR',

  // === Recommendation Provider LinkedIn Profiles ===
  SHUBHAM_MITTAL_LINKEDIN: 'https://www.linkedin.com/in/shubham-mittal-03112/',
  RUDRANSH_SOLANKI_LINKEDIN: 'https://www.linkedin.com/in/rudransh-solanki-b06381199/',
  BHAVUK_JAIN_LINKEDIN: 'https://www.linkedin.com/in/jainbhavuk555/',
  PRATIK_SHINDE_LINKEDIN: 'https://www.linkedin.com/in/pratik-shinde-qa-automation/',
  SAGAR_SAINI_LINKEDIN: 'https://www.linkedin.com/in/sagar-saini-387984221/',
  AMIT_RAIYANI_LINKEDIN: 'https://www.linkedin.com/in/amit-raiyani-2211a19b/',
  AAKASH_SHARMA_LINKEDIN: 'https://www.linkedin.com/in/aakash-sharma-76501018b/',
  SHASHANK_DWIVEDI_LINKEDIN: 'https://www.linkedin.com/in/shashankdvd1/',
  CHITRAKSH_LUTHRA_LINKEDIN: 'https://www.linkedin.com/in/chitraksh-luthra-17a997157/',
  AKASH_MEWATI_LINKEDIN: 'https://www.linkedin.com/in/akash-mewati-775115126/',
  SURAJ_KUMAR_LINKEDIN: 'https://www.linkedin.com/in/surajk-dev/',

  // === Certificate Links (Education.tsx) ===
  CERT_CODING_NINJAS_SYSTEM_DESIGN: 'https://certificate.codingninjas.com/verify/a2c430e74b698a89',
  CERT_CODING_NINJAS_FULLSTACK_PDF: 'https://ninjasfiles.s3.amazonaws.com/certificate145932965cb92a3b6e5133093e702d643589b42.pdf',
  CERT_CODING_NINJAS_DBMS: 'https://certificate.codingninjas.com/verify/08c120c89135b0d0',
  CERT_CODING_NINJAS_DSA_PDF: 'https://ninjasfiles.s3.amazonaws.com/certificate361790b9c66ce74cfb632b6502f2227f6caef0.pdf',
  CERT_CODING_NINJAS_CPP: 'https://certificate.codingninjas.com/',
  CERT_NAMASTE_JAVASCRIPT: 'https://namastedev.com/a.mohit1998/certificates/namaste-javascript',
  CERT_COURSERA_CYBERSECURITY: 'https://www.coursera.org/account/accomplishments/verify/52DBN56NHRD2',
  CERT_COURSERA_WRITING: 'https://www.coursera.org/account/accomplishments/verify/UQ5X7Q8XSMTP',
  CERT_COURSERA_CYBER_CONFLICTS: 'https://www.coursera.org/account/accomplishments/verify/',
  CERT_UDEMY_SQL: 'https://www.udemy.com/certificate/',
} as const

export type LinkKey = keyof typeof LINKS
